import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const EducationalBrochure = () => {
    return (
        <svg width="42" height="48" viewBox="0 0 42 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#skbghfiica)">
                <path d="M31.716 19.008h-16.01a.633.633 0 1 1 0-1.267h16.01a.611.611 0 0 1 .656.634.64.64 0 0 1-.656.633zm0-3.174h-16.01a.633.633 0 1 1 0-1.267h16.01a.61.61 0 0 1 .656.633.641.641 0 0 1-.656.634zm0-3.175h-16.01a.633.633 0 1 1 0-1.267h16.01a.61.61 0 0 1 .656.633.641.641 0 0 1-.656.634z" fill="#002856"/>
                <path d="M5.27 1h-.874A2.835 2.835 0 0 0 1.5 3.82v34.327a2.836 2.836 0 0 0 2.896 2.82h.874V1.001zM8.287 47l1.915-1.35L12.058 47v-6.033h-3.77V47z" stroke="#002856" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M38.857 1H7.532v39.967H38.21a1.75 1.75 0 0 0 1.75-1.772V2.117A1.2 1.2 0 0 0 38.856 1zm-2.85 19.856a2.474 2.474 0 0 1-2.459 2.488H14.394a2.473 2.473 0 0 1-2.458-2.488V10.804a2.473 2.473 0 0 1 2.458-2.534h19.154a2.473 2.473 0 0 1 2.459 2.534v10.052z" stroke="#002856" stroke-width="1.5" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="skbghfiica">
                    <path fill="#fff" transform="translate(.5)" d="M0 0h41v48H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default EducationalBrochure;
